import { dashboardConstants } from '../_constants';

const {
	GET_TOTAL_REGISTRATION_COUNT_SUMMARY_START,
	GET_TOTAL_REGISTRATION_COUNT_SUMMARY_FAILED,
	GET_TOTAL_REGISTRATION_COUNT_SUMMARY_SUCCESS,
	FILTER_TERMINAL_SUMMARY_COUNT_START,
	FILTER_TERMINAL_SUMMARY_COUNT_SUCCESS,
	FILTER_TERMINAL_SUMMARY_COUNT_FAILED,
} = dashboardConstants;

const initialState = {
	countLoading: false,
	error: false,
	countSummary: {
		successfulCount: 0,
		failedCount: 0,
		recordCount: 0,
	},
	filteredCountSummary: {
		successfulCount: 0,
		failedCount: 0,
		recordCount: 0,
	},
};

const DashboardCountReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		// case GET_ALL_TERMINAL_SUMMARY_START:
		//   return {
		//     ...state,
		//     isLoading: true,
		//   };
		// case GET_ALL_TERMINAL_SUMMARY_SUCCESS:
		//   const { content, count, success, failed, pending } = payload;
		//   return {
		//     ...state,
		//     isLoading: false,
		//     terminalSummaryData: content,
		//     summaryCount: count,
		//     summarySuccess: success,
		//     summaryFailed: failed,
		//     summaryPending: pending
		//   };
		// case GET_ALL_TERMINAL_SUMMARY_FAILED:
		//   return {
		//     ...state,
		//     isLoading: false,
		//     error: payload,
		//   };
		// case FILTER_TERMINAL_SUMMARY_START:
		//   return { ...state, isLoading: true };
		// case FILTER_TERMINAL_SUMMARY_SUCCESS:
		//   const { content: filteredTerminalSummary, count: filteredSummaryCount, success: filteredSuccess, failed: filteredFailed, pending: filteredPending } =
		//     payload;
		//   return {
		//     ...state,
		//     isLoading: false,
		//     terminalSummaryData: filteredTerminalSummary,
		//     summaryCount: filteredSummaryCount,
		//     summarySuccess: filteredSuccess,
		//     summaryFailed: filteredFailed,
		//     summaryPending: filteredPending
		//   };
		// case FILTER_TERMINAL_SUMMARY_FAILED:
		//   return {
		//     ...state,
		//     isLoading: false,
		//     error: payload,
		//   };
		case GET_TOTAL_REGISTRATION_COUNT_SUMMARY_START:
			return {
				...state,
				countLoading: true,
			};
		case GET_TOTAL_REGISTRATION_COUNT_SUMMARY_SUCCESS:
			const { successfulCount, failedCount, recordCount } = payload;
			return {
				...state,
				countLoading: false,
				countSummary: {
					successfulCount: successfulCount,
					failedCount: failedCount,
					recordCount: recordCount,
				},
			};
		case GET_TOTAL_REGISTRATION_COUNT_SUMMARY_FAILED:
			return {
				...state,
				countLoading: false,
				error: payload,
			};
		case FILTER_TERMINAL_SUMMARY_COUNT_START:
			return { ...state, countLoading: true };
		case FILTER_TERMINAL_SUMMARY_COUNT_SUCCESS:
			const {
				successfulCount: filteredSuccessfulCount,
				failedCount: filteredFailedCount,
				recordCount: filteredPendingCount,
			} = payload;
			return {
				...state,
				countLoading: false,
				filteredCountSummary: {
					successfulCount: filteredSuccessfulCount,
					failedCount: filteredFailedCount,
					recordCount: filteredPendingCount,
				},
			};
		case FILTER_TERMINAL_SUMMARY_COUNT_FAILED:
			return {
				...state,
				countLoading: false,
				error: payload,
			};
		default:
			return state;
	}
};

export default DashboardCountReducer;
